// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3vAQa","top":"styles_top__16g0Q","left":"styles_left__27KF3","description":"styles_description__8xjqu"};